"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Set up load event profiling and beaconing.
 *
 * @param profiler ClientProfiler instance
 *
 * @deprecated This will be removed b/c the `loaded ${pageName}` and `onload
 *   completed` events are not tracked anywhere. See
 *   https://gitlab.zgtools.net/search?search=%22%27loaded+%22+%7C+%22%5C%22loaded+%22+%7C+%22%27onload+%22+%7C+%22%5C%22onload%22&nav_source=navbar&project_id=9336&group_id=2149&search_code=true&repository_ref=master
 */
function initOnLoadBeacon(profiler) {
    const { appConfig: { pageLoadBeaconDelay, staticDimensions: { pageName }, }, beacon, profile, } = profiler;
    // Bail if we're not in a browser environment. See PERF-802.
    if (typeof window === 'undefined')
        return;
    const { addEventListener, setTimeout } = window;
    // Beacon our initial payload w/ expected OUT events
    addEventListener('load', () => {
        profile(`loaded ${pageName}`);
        setTimeout(beacon, pageLoadBeaconDelay);
        profile('onload completed');
    });
}
exports.default = initOnLoadBeacon;
